import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { assetImg } from "@/modules/moduleImporter";
import { IGameTableType } from "@/types/GlobalTypes";
import nary from "@/modules/nary";
import { betGroupProp } from "@/modules/commonMobile";

import "./index.scss";

//Head & Tail
export default class M10 extends React.PureComponent<IGameTableType> {
	//for win animation
	readonly topGroup  = ["1,1,1", "1,2,2", "2,1,1", "2,2,2"];
	readonly bottomGroup = ["1,1,2", "1,2,1", "2,1,2", "2,2,1"];

	readonly leftGroup = ["1,1,1", "1,2,2", "1,1,2", "1,2,1"];
	readonly rightGroup = ["2,1,1", "2,2,2", "2,1,2", "2,2,1"];

	readonly topGroupImages = [[
		assetImg("m10", "1", "01"),
		assetImg("m10", "1", "02"),
		assetImg("m10", "1", "03")
	], [ 
		assetImg("m10", "1", "11"),
		assetImg("m10", "2", "12"),
		assetImg("m10", "2", "13")
	], [
		assetImg("m10", "2", "21"),
		assetImg("m10", "1", "22"),
		assetImg("m10", "1", "23")
	], [
		assetImg("m10", "2", "31"),
		assetImg("m10", "2", "32"),
		assetImg("m10", "2", "33")
	]];
	
	readonly bottomGroupImages = [[
		assetImg("m10", "1", "41"),
		assetImg("m10", "1", "42"),
		assetImg("m10", "2", "43")
	], [
		assetImg("m10", "1", "51"),
		assetImg("m10", "2", "52"),
		assetImg("m10", "1", "53")
	], [
		assetImg("m10", "2", "61"),
		assetImg("m10", "1", "62"),
		assetImg("m10", "2", "63")
	], [
		assetImg("m10", "2", "71"),
		assetImg("m10", "2", "72"),
		assetImg("m10", "1", "73")
	]];

	render() {
		const { 
			mobile,
			chipBase,
			bets,
			betOutOfBounds,
			langdata,
			insertBet
		} = this.props;
		
		const win = this.props.win || "";
		const wins = win.split(",");
		let heads = 0, tails = 0;
		for (const a of wins)
			if (a === "1") heads++;
			else if (a === "2") tails++;

		const commonChipProps = {
			mobile,
			chipBase,
			bets,
			betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};
		
		return (
		this.props.portrait ?
		<div className="sl-table m10-portrait">
			<div className="row">
				<div className={"sl-bet col-xs-6 sl-green-old" + (heads > tails ? " sl-yellow-alternating" : "")}
					{...betGroupProp(this, "head", "n50")}
					// bet="head" pcode={this.props.pcode} group="n50"
					onClick={insertBet}>
					{ assetImg("m10", "1") }
					
					<div>&nbsp;{langdata["txt_head"]}</div>
					<div className="bet-type">1:0.95</div>
					<Chips {...commonChipProps} betKey="head+n50" />
				</div>
				<div className={"sl-bet col-xs-6 sl-green-old" + (tails > heads ? " sl-yellow-alternating" : "")}
					{...betGroupProp(this, "tail", "n50")}
					// bet="tail" pcode={this.props.pcode} group="n50"
					onClick={insertBet}>
					{ assetImg("m10", "2") }
					
					<div>&nbsp;{langdata["txt_tail"]}</div>
					<div className="bet-type">1:0.95</div>
					<Chips {...commonChipProps} betKey="tail+n50" />
				</div>
			</div>

			<div className="row">
				<div className={"sl-bet col-xs-6 sl-red-lighten" + (this.leftGroup.includes(win) ? " sl-yellow-alternating" : "")}
					{...betGroupProp(this, "left", "n50")}
					// bet="left" pcode={this.props.pcode} group="n50"
					onClick={insertBet}>
					{langdata["txt_left"]} - {langdata["txt_key"]} 5%
					<div className="bet-type">1:0.95</div>
					<Chips {...commonChipProps} betKey="left+n50" />
				</div>
				<div className={"sl-bet col-xs-6 sl-black-lighten" + (this.rightGroup.includes(win) ? " sl-yellow-alternating" : "")}
					{...betGroupProp(this, "right", "n50")}
					// bet="right" pcode={this.props.pcode} group="n50"
					onClick={insertBet}>
					{langdata["txt_right"]} - {langdata["txt_key"]} 5%
					<div className="bet-type">1:0.95</div>
					<Chips {...commonChipProps} betKey="right+n50" />
				</div>
			</div>

			<div className="row">
			{
				[...this.topGroup, ...this.bottomGroup].map((group, idx) =>
					<div key={"row_" + idx} className={"sl-bet m10 col-xs-3 sl-green-old" + (win === group ? " sl-yellow-alternating" : "")}
					{...betGroupProp(this, group, "n")}
					// bet={group} pcode={this.props.pcode} group="n"
					onClick={insertBet}>
						{
							group.split(",").map((num, _idx) =>
								assetImg("m10", num + "", "tGbG" + idx + "_" + _idx, "smallest"),
							)
						}
						<div className="bet-type">1:6.8</div>
						<Chips {...commonChipProps} betKey={group + "+n"} />
					</div>
				)
			}
			</div>
			
			<div className="row">
				<div className={"sl-bet m10 col-xs-6 sl-green-old" + (heads === 2 ? " sl-yellow-alternating" : "")}
					{...betGroupProp(this, "c1", "c")}
					// bet={"c1"} pcode={this.props.pcode} group="c"
					onClick={insertBet}>
					{ assetImg("m10", "1", "", "smaller") }
					{ assetImg("m10", "1", "", "smaller") }
					{ assetImg("m10", "2", "", "smaller") }
					<div className="bet-type">1:1.6</div>
					<Chips {...commonChipProps} betKey={"c1+c"} />
				</div>

				<div className={"sl-bet m10 col-xs-6 sl-green-old" + (tails === 2 ? " sl-yellow-alternating" : "")}
					{...betGroupProp(this, "c2", "c")}
					// bet={"c2"} pcode={this.props.pcode} group="c"
					onClick={insertBet}>
					{ assetImg("m10", "2", "", "smaller") }
					{ assetImg("m10", "2", "", "smaller") }
					{ assetImg("m10", "1", "", "smaller") }
					<div className="bet-type">1:1.6</div>
					<Chips {...commonChipProps} betKey={"c2+c"} />
				</div>
			</div>

			{
				nary(3).map(num =>
					<div key={"row_" + num} className="row">
						<div className="sl-green-old col-20p">
							{langdata["txt_coin"]} {num}
						</div>
						{
							nary(2).map(_num =>
								<div key={"cell_" + num + "_" + _num} className={"sl-bet col-40p sl-green-old" + (Number(wins[num - 1]) === _num ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, "d" + ((num - 1) * 2 + _num), "d")}
									// bet={"d" + ((num - 1) * 2 + _num)} pcode={this.props.pcode} group="d"
									onClick={insertBet}>
									{ assetImg("m10", _num + "", "") }
									<div className="bet-type">1:0.95</div>
									<Chips {...commonChipProps} betKey={"d" + ((num - 1) * 2 + _num) + "+d"} />
								</div>
							)
						}
					</div>
				)
			}
			
		</div>
		
		: <div className="sl-table">
				<div className="m10-row m10-row-top">
					<div className={"sl-bet m10-table-cell sl-green-old m10-top-three" + (heads === 2 ? " sl-yellow-alternating" : "")}
						{...betGroupProp(this, "c1", "c")}
						// bet="c1" pcode={this.props.pcode} group="c"
						onClick={insertBet}>
						{ assetImg("m10", "1", "m10_1") }
						{ assetImg("m10", "1", "m10_2") }
						{ assetImg("m10", "2", "m10_3") }
						<div className="bet-type">1:1.6</div>
						<Chips {...commonChipProps} betKey={"c1+c"} />
						<Tooltip {...commonTooltipProps} bet={bets["c1+c"]} />
					</div>
					{
						nary(3).map((item, idx) => {
							const betKey1 = "d" + (idx * 2 + 1), betKey2 = "d" + (idx * 2 + 2);
							return (
								<div key={"m10_coin" + idx} className="m10-table-cell m10-green-darken m10-top-coin">
									<div className="m10-top-text">
										<div>{`${langdata["txt_coin"]} ${item}`}</div>
										<div className="bet-type">1:0.95</div>
									</div>
									<div className={"sl-bet sl-green-old m10-table-cell" + (wins[idx] === "1" ? " sl-yellow-alternating" : "")}
										{...betGroupProp(this, betKey1, "d")}
										// bet={betKey1} pcode={this.props.pcode} group="d"
										onClick={insertBet}>
										{ assetImg("m10", "1") }
										<Chips {...commonChipProps} betKey={betKey1 + "+d"} />
										<Tooltip {...commonTooltipProps} bet={bets[betKey1 + "+d"]} />
									</div>
									<div className={"sl-bet sl-green-old m10-table-cell" + (wins[idx] === "2" ? " sl-yellow-alternating" : "")}
										{...betGroupProp(this, betKey2, "d")}
										// bet={betKey2} pcode={this.props.pcode} group="d"
										onClick={insertBet}>
										{ assetImg("m10", "2") }
										<Chips {...commonChipProps} betKey={betKey2 + "+d"} />
										<Tooltip {...commonTooltipProps} bet={bets[betKey2 + "+d"]} />
									</div>
								</div>
							);
						})
					}
					<div className={"sl-bet m10-table-cell sl-green-old m10-top-three" + (tails === 2 ? " sl-yellow-alternating" : "")}
						{...betGroupProp(this, "c2", "c")}
						// bet="c2" pcode={this.props.pcode} group="c"
						onClick={insertBet}>
						{ assetImg("m10", "2", "m10_4") }
						{ assetImg("m10", "2", "m10_5") }
						{ assetImg("m10", "1", "m10_6") }
						<div className="bet-type">1:1.6</div>
						<Chips {...commonChipProps} betKey={"c2+c"} />
						<Tooltip {...commonTooltipProps} bet={bets["c2+c"]} />
					</div>
				</div>
				<div className="m10-row m10-row-middle">
					<div className={"sl-bet m10-table-cell m10-big-coin sl-green-old" + (heads > tails ? " sl-yellow-alternating" : "")}
						{...betGroupProp(this, "head", "n50")}
						// bet="head" pcode={this.props.pcode} group="n50"
						onClick={insertBet}>
						<div>{langdata["txt_key"]} 5%</div>
						{ assetImg("m10", "1") }
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey={"head+n50"} />
						<Tooltip {...commonTooltipProps} bet={bets["head+n50"]} />
					</div>
					
					<div className="m10-table-cell">
						<div className="m10-row">
						{
							this.topGroup.map((item, idx) => (
								<div key={`tg${idx}`} className={"sl-bet m10-table-cell sl-green-old" + (win === item ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, item, "n")}
									// bet={item} pcode={this.props.pcode} group="n"
									onClick={insertBet}>
									{ this.topGroupImages[idx] }
									<div className="bet-type">1:6.8</div>
									<Chips {...commonChipProps} betKey={item + "+n"} />
									<Tooltip {...commonTooltipProps} bet={bets[item + "+n"]} />
								</div>
							))
						}
						</div>
							
						<div className="m10-row">
						{
							this.bottomGroup.map((item, idx) => (
								<div key={`bg${idx}`} className={"sl-bet m10-table-cell sl-green-old" + (win === item ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, item, "n")}
									// bet={item} pcode={this.props.pcode} group="n"
									onClick={insertBet}>

									{ this.bottomGroupImages[idx] }
									<div className="bet-type">1:6.8</div>
									<Chips {...commonChipProps} betKey={item + "+n"} />
									<Tooltip {...commonTooltipProps} bet={bets[item + "+n"]} />
								</div>
							))
						}
						</div>
					</div>
					
					<div className={"sl-bet m10-table-cell m10-big-coin sl-green-old" + (tails > heads ? " sl-yellow-alternating" : "")}
						{...betGroupProp(this, "tail", "n50")}
						// bet="tail" pcode={this.props.pcode} group="n50"
						onClick={insertBet}>
						<div>{langdata["txt_key"]} 5%</div>
						{ assetImg("m10", "2") }
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey={"tail+n50"} />
						<Tooltip {...commonTooltipProps} bet={bets["tail+n50"]} />
					</div>
				</div>
				<div className="m10-row-bottom">
					<div className={"sl-bet m10-red m10-table-cell" + (this.leftGroup.includes(win) ? " sl-yellow-alternating" : "")}
						{...betGroupProp(this, "left", "n50")}
						// bet="left" pcode={this.props.pcode} group="n50"
						onClick={insertBet}>
						<div>{langdata["txt_left"]} - {langdata["txt_key"]} 5%</div>
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey={"left+n50"} />
						<Tooltip {...commonTooltipProps} bet={bets["left+n50"]} />
					</div>
					<div className={"sl-bet m10-grey m10-table-cell" + (this.rightGroup.includes(win) ? " sl-yellow-alternating" : "")}
						{...betGroupProp(this, "right", "n50")}
						// bet="right" pcode={this.props.pcode} group="n50"
						onClick={insertBet}>
						<div>{langdata["txt_right"]} - {langdata["txt_key"]} 5%</div>
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey={"right+n50"} />
						<Tooltip {...commonTooltipProps} bet={bets["right+n50"]} />
					</div>
				</div>
			</div>
		);
	}
}
